import { HexColorPicker, HexColorInput } from "react-colorful";
import { Box, Typography } from "@mui/material";

interface ColorPickerProps {
    value: string;
    onChange: (value: string) => void;
}

export const ColorPicker = ({ value, onChange }: ColorPickerProps) => {
    // Normalize value to #rrggbb format if needed
    const safeValue = value && value.startsWith("#") ? value : "#000000";

    return (
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}>

            <HexColorPicker color={safeValue} onChange={onChange} />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <HexColorInput
                    color={safeValue}
                    onChange={onChange}
                    prefixed
                    style={{
                        width: "110px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontFamily: "inherit",
                    }}
                />
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        backgroundColor: safeValue,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                    }}
                />
            </Box>
        </Box>
    );
};